export default __webpack_public_path__ + "static/media/Aprobación de compras.a7eaabb4.png";